import { usePageProps } from "common/hooks/data/usePageProps"
import { EditPageProps } from "pages/edit/index.page"
import React from "react"
import dynamic from "next/dynamic"
import { Partner } from "common/types/graphql"
import { PartnersView } from "./Partners.view"

const PartnersEdit = dynamic<PartnersProps>(() =>
  import("./Partners.edit").then((mod) => mod.PartnersEdit),
)

export interface PartnersProps {
  partners?: Partner[]
}

export const Partners = ({ partners }: PartnersProps) => {
  const { editing } = usePageProps<EditPageProps>()
  const PartnersComponent = editing ? PartnersEdit : PartnersView

  return <PartnersComponent partners={partners} />
}
